import {
    CHANGE_RECALL_NUMBER,
    CHECK_RECONNECT_SESSION,
    CLEAR_RECALL_SESSION,
    GET_MUTE_CONSULTATION_ID,
    GET_MUTE_ID,
    GET_USERS_WEB_RTC,
    RECONNECT_SESSION,
    SET_ACTIVE_SESSION, SET_MONITORING_HUB_ERROR,
    SET_RECALL_NUMBER, SET_STATUS_HUB_ERROR, SET_USER_DATA_HUB_ERROR, SET_DIALER_HUB_ERROR,
    SUCCESS_SESSION_RECONNECTED, SET_PICK_UP_NUMBER, PICKUP_CALL_TRIGGER, SET_ERROR_JS_SIP, SET_ERROR_JS_SIP_TAB, SET_SPY_SESSION_ID, SET_SPY_CALL_ANSWERED_TICK, SET_SIP_USER_BUSY,
    SET_TRANSCRIPTION_HUB_STATUS
} from "../types/types";
import type {TranscriptionHubStatusPayload} from "../../components/Statistics/ManualEvaluationDialog/manualEvaluationTranscription";
import {CHANGE_INTERNET_STATUS, RECONNECT_TAB, SET_ACTIVE_SESSION_TAB} from "../types/typesWebRTC";

export const setSearchResults = (results: []) => ({
    type: GET_USERS_WEB_RTC,
    payload: results,
});

export const setSearchError = (error: boolean) => ({
    type: GET_USERS_WEB_RTC,
    payload: error,
});


export const getMuteId = (muteId: number) => ({
    type: GET_MUTE_ID,
    payload: muteId,
});

export const getConsultationMuteId = (muteId: number) => ({
    type: GET_MUTE_CONSULTATION_ID,
    payload: muteId,
});

export const setActiveSession = (active: any) => ({
    type: SET_ACTIVE_SESSION,
    payload: active,
});

export const setReconnectSession = (activeConnect: any) => ({
    type: RECONNECT_SESSION,
    payload: activeConnect,
});

export const checkSipConnection = (activeConnect: any) => ({
    type: CHECK_RECONNECT_SESSION,
    payload: activeConnect,
});

export const sessionReconnected = (reconnected: any) => ({
    type: SUCCESS_SESSION_RECONNECTED,
    payload: reconnected,
});

export const setRecallNumber = (data: any) => ({
    type: SET_RECALL_NUMBER,
    payload: data,
});

export const setPickUpNumber = (data: any) => ({
    type: SET_PICK_UP_NUMBER,
    payload: data,
});

export const setSpySessionId = (sessionId: string | null) => ({
    type: SET_SPY_SESSION_ID,
    payload: sessionId,
});

export const setSpyCallAnsweredTick = () => ({
    type: SET_SPY_CALL_ANSWERED_TICK,
    payload: Date.now(),
});

export const setSipUserBusy = (busy: boolean) => ({
    type: SET_SIP_USER_BUSY,
    payload: busy,
});

export const triggerPickupCall = () => ({
    type: PICKUP_CALL_TRIGGER,
    payload: Date.now(),
});

export const clearRecallSession = () => ({
    type: CLEAR_RECALL_SESSION,
});


export const changeRecallNumber = (bool: boolean) => ({
    type: CHANGE_RECALL_NUMBER,
    payload: bool,
});

export const changeInternetStatus = (state: any) => (
    {
        type: CHANGE_INTERNET_STATUS,
        payload: state,
    })

export const setMonitoringHubError = (state: any) => (
    {
        type: SET_MONITORING_HUB_ERROR,
        payload: state,
    })

export const setStatusHubError = (state: any) => (
    {
        type: SET_STATUS_HUB_ERROR,
        payload: state,
    })

export const setUserDataHubError = (state: any) => (
    {
        type: SET_USER_DATA_HUB_ERROR,
        payload: state,
    })

export const setTranscriptionHubStatus = (payload: TranscriptionHubStatusPayload) => ({
    type: SET_TRANSCRIPTION_HUB_STATUS,
    payload,
});

export const setDialerHubError = (state: any) => (
    {
        type: SET_DIALER_HUB_ERROR,
        payload: state,
    })

export const setActiveSessionTab = (state: any) => (
    {
        type: SET_ACTIVE_SESSION_TAB,
        payload: state,
    })

export const reconnectTab = (state: boolean) => (
    {
        type: RECONNECT_TAB,
        payload: state,
    })

export const setErrorJsSip = (state: boolean) => (
    {
        type: SET_ERROR_JS_SIP,
        payload: state,
    })

export const setErrorJsSipTab = (state: boolean) => (
    {
        type: SET_ERROR_JS_SIP_TAB,
        payload: state,
    })
